import { TRAINING_FORM_TYPES } from "@/lib/form-categories";
import ManagerFormsIndex from "./forms.manager._index";

export default function TrainingIndex() {
  return (
    <ManagerFormsIndex
      formTypes={TRAINING_FORM_TYPES}
      pageTitle="Training"
      pageDescription="Review site inductions, toolbox talks, and training records."
      detailBasePath="forms/training"
    />
  );
}
